import { X } from "lucide-react";
import { useSettingsContext } from "../../../hook/useSettingsContext";
import PlusMinus from "../../../others/PlusMinus";

export default function TabNavigation() {
    const { tabs, activeTab, setActiveTab, sidebarOpen, setSidebarOpen } =
        useSettingsContext();

    return (
        <>
            <aside
                className={`fixed wp:static top-0 left-0 w-72 max-wplg:w-64 bg-white overflow-visible wp:border-r wp:border-gray-200 transform transition-transform duration-300 ease-in-out
        ${
            sidebarOpen ? "translate-x-0 z-[999999]" : "-translate-x-full"
        } wp:translate-x-0`}
            >
                {/* Close button for mobile */}
                <div className="absolute top-0 end-0 -me-14 p-1">
                    <button
                        className={`flex justify-center items-center w-12 h-12 bg-white rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500 wp:hidden ${
                            !sidebarOpen && "hidden"
                        }`}
                        onClick={() => setSidebarOpen(false)}
                    >
                        <X className="w-5 h-5" />
                    </button>
                </div>
                <div className="overflow-y-auto overflow-x-hidden h-screen wp:min-h-screen">
                    <div className="py-8 px-5 max-wp:p-5 border-b border-gray-200">
                        <div className="flex items-center gap-4">
                            <div className="w-12">
                                <PlusMinus />
                            </div>
                            <div>
                                <h1 className="text-xl font-bold text-gray-900 p-0">
                                    Quantity Controls
                                </h1>
                                <p className="text-sm text-gray-500 mt-1">
                                    Plugin Settings
                                </p>
                            </div>
                        </div>
                    </div>

                    <nav className="space-y-2 p-5 ">
                        {tabs.map((tab) => {
                            const Icon = tab.icon;
                            return (
                                <button
                                    key={tab.id}
                                    onClick={() => {
                                        setActiveTab(tab.id);
                                        setSidebarOpen(false);
                                    }}
                                    className={`w-full flex items-center gap-3 px-3 py-3 rounded-lg font-medium text-sm transition-colors ${
                                        activeTab === tab.id
                                            ? "bg-blue-600 text-white"
                                            : "text-gray-700 hover:bg-blue-50"
                                    }`}
                                >
                                    <Icon size={18} />
                                    {tab.label}
                                </button>
                            );
                        })}
                    </nav>
                </div>
            </aside>
            {/* Overlay (click to close) */}
            {sidebarOpen && (
                <div
                    className="fixed inset-0 bg-slate-600 bg-opacity-75 z-[999990] wp:hidden"
                    onClick={() => setSidebarOpen(false)}
                ></div>
            )}
        </>
    );
}
